import { TrackingPayload } from '@blk/aw-bff-typescript-models';
import { isCloud } from '@blk/aw-env-detection';
import {
  ACCEPT_HEADER,
  API_KEY_HEADER,
  EnvType,
  ORIGIN_TIME_STAMP_HEADER,
  REQUEST_ID_HEADER,
} from '../../APIConstants';
import { wrapAGraphRequest } from '../../utils/AGraphWrapper';
import { getAGraphBaseUrl, getApiBaseUrlSuffix, setAGraphHeaders } from '../../utils/ApiUtils';
import { isAGraphEnabled } from './AGraphUtils';
import { awBffServerSettings } from './Base';
import { AW_BFF_API_URL, AW_BFF_API_URL_AGRAPH, LOG_URL } from './Constants';

export function logPayload(payload: TrackingPayload[], keepalive = false): void {
  const { getAladdinApiKey, getEnvTypeFn } = awBffServerSettings;
  const envType = getEnvTypeFn ? getEnvTypeFn() : EnvType.DEFAULT;
  if (isAGraphEnabled()) {
    const url = getAGraphBaseUrl(AW_BFF_API_URL_AGRAPH) + LOG_URL;
    /*
     * AGraph doesn't support sendBeacon so we'll need to use fetch() with keepalive: true
     * We'll also need all the AGraph headers
     */
    const config: {
      headers: Record<string, string>;
    } = {
      headers: {},
    };
    setAGraphHeaders(config, getAladdinApiKey?.(), envType, 'stripe', false);
    const wrappedPayload = wrapAGraphRequest(payload, 'trackingPayloads', true);
    const {
      Authorization,
      Traceparent,
      [ACCEPT_HEADER]: acceptHeader,
      [API_KEY_HEADER]: apiKey,
      [ORIGIN_TIME_STAMP_HEADER]: originTimeStamp,
      [REQUEST_ID_HEADER]: requestId,
    } = config.headers;
    void fetch(url, {
      body: JSON.stringify(wrappedPayload),
      keepalive,
      headers: {
        ...(!isCloud() && {
          Accept: 'application/json',
          [API_KEY_HEADER]: apiKey,
          [ORIGIN_TIME_STAMP_HEADER]: originTimeStamp,
          [REQUEST_ID_HEADER]: requestId,
        }),
        ...(isCloud() && {
          Authorization,
          Traceparent,
          [ACCEPT_HEADER]: acceptHeader,
        }),
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });
  } else {
    const url = AW_BFF_API_URL + getApiBaseUrlSuffix(envType, '_') + LOG_URL;
    void fetch(url, {
      body: JSON.stringify(payload),
      keepalive,
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });
  }
}
